import cx from 'classnames';
import { Space } from 'antd';
import { useSelector } from 'react-redux';

import { THEME } from '../../config/commons';
import { Store } from '../../state/store.interface';
import larviaLogoDark from '../../assets/larvia-logo-dark.png';
import larviaLogoLight from '../../assets/larvia-logo-light.png';

import './AppHeader.scss';
import { SwitchTheme } from './SwitchTheme';
import styles from './AppHeader.module.scss';

export default function AppHeader () {
  const { analysis: detailAnalysis, theme } = useSelector((state: Store) => state.detail);
  const isLightTheme = theme === THEME.LIGHT;

  if (!detailAnalysis._id) {
    return null;
  }

  return (
    <div className={cx(styles.header, isLightTheme ? styles.headerLight : styles.headerDark)}>
      <div className={styles.leftHeader}>
        <img
          className={styles.image}
          src={isLightTheme ? larviaLogoLight : larviaLogoDark}
          height={26}
          alt='Larvia logo'
        />

        <div className={styles.titlePublic}>
          {detailAnalysis.code}
        </div>
      </div>

      <Space className={styles.rightHeader} size='large'>
        <SwitchTheme isAnalysisPublic={true} size='default' />
      </Space>
    </div>
  );
}
